// @core/api/endpoints/payment/update_payment_route.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdatePaymentRouteRequest,
  UpdatePaymentRouteResponse,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Update payment route
 * Updates an existing payment route with the provided data. Returns the updated resource.
 */
export async function UpdatePaymentRoute(
  id: string,
  data: UpdatePaymentRouteRequest,
  options?: RequestOptions
): Promise<UpdatePaymentRouteResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/payment-routes/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.patch<UpdatePaymentRouteResponse>(requestPath, data, requestOptions);
}
